import { SxProps, Theme } from '@mui/material';
import { Color } from '../../../../shared/utils/colors';

export const customDateRangeAdapterStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  gridColumn: '1 / -1',
  order: -1,
  boxSizing: 'border-box',
  '& .MuiFormControl-root.MuiTextField-root': {
    height: '56px',
    width: '100%',
    fill: Color.blackMuted,
    '& input': {
      height: '56px',
      boxSizing: 'border-box',
      borderColor: Color.solidGray,
    },
  },
  '& .MuiMultiInputDateRangeField-root': {
    width: '100%',
  },
  '& .MuiDateRangePicker-root': {
    width: '100%',
  },
  '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiOutlinedInput-adornedEnd':
    {
      paddingRight: 0,
    },
};

